/** Public client DSN (project anders-kafka-fe); shared by the Sentry SDK init and the inline hydration watchdog. */
export const SENTRY_DSN = 'https://55e4b6a095ad77610a578952eb483069@sentry.integritty.cz/44';
